export enum BorderStyle {
  none,
  solid,
}
